module.exports = __webpack_public_path__ + "img/AfCFTA CARAVAN 4.7a0222f3.png";